"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _disableDragEventPropagation = require("./disableDragEventPropagation");
Object.keys(_disableDragEventPropagation).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _disableDragEventPropagation[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _disableDragEventPropagation[key];
    }
  });
});
var _getCarouselRootPadding = require("./getCarouselRootPadding");
Object.keys(_getCarouselRootPadding).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getCarouselRootPadding[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getCarouselRootPadding[key];
    }
  });
});
var _getCurrentSlideIndex = require("./getCurrentSlideIndex");
Object.keys(_getCurrentSlideIndex).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getCurrentSlideIndex[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getCurrentSlideIndex[key];
    }
  });
});
var _getDotMargin = require("./getDotMargin");
Object.keys(_getDotMargin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDotMargin[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getDotMargin[key];
    }
  });
});
var _getDotSize = require("./getDotSize");
Object.keys(_getDotSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getDotSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getDotSize[key];
    }
  });
});
var _getIndex = require("./getIndex");
Object.keys(_getIndex).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getIndex[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getIndex[key];
    }
  });
});
var _getNavigationArrowFontSize = require("./getNavigationArrowFontSize");
Object.keys(_getNavigationArrowFontSize).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getNavigationArrowFontSize[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getNavigationArrowFontSize[key];
    }
  });
});
var _getNavigationArrowHeight = require("./getNavigationArrowHeight");
Object.keys(_getNavigationArrowHeight).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getNavigationArrowHeight[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getNavigationArrowHeight[key];
    }
  });
});
var _getNavigationArrowWidth = require("./getNavigationArrowWidth");
Object.keys(_getNavigationArrowWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getNavigationArrowWidth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getNavigationArrowWidth[key];
    }
  });
});
var _getRectangleWidth = require("./getRectangleWidth");
Object.keys(_getRectangleWidth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getRectangleWidth[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getRectangleWidth[key];
    }
  });
});
var _getSlidesPerView = require("./getSlidesPerView");
Object.keys(_getSlidesPerView).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getSlidesPerView[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getSlidesPerView[key];
    }
  });
});
var _isCarouselAtTheEnd = require("./isCarouselAtTheEnd");
Object.keys(_isCarouselAtTheEnd).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isCarouselAtTheEnd[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isCarouselAtTheEnd[key];
    }
  });
});
var _isNextSlide = require("./isNextSlide");
Object.keys(_isNextSlide).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isNextSlide[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isNextSlide[key];
    }
  });
});
var _isPaginationStepHidden = require("./isPaginationStepHidden");
Object.keys(_isPaginationStepHidden).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isPaginationStepHidden[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isPaginationStepHidden[key];
    }
  });
});
var _isPreviousSlide = require("./isPreviousSlide");
Object.keys(_isPreviousSlide).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isPreviousSlide[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isPreviousSlide[key];
    }
  });
});
var _isSlidesLoopEnabled = require("./isSlidesLoopEnabled");
Object.keys(_isSlidesLoopEnabled).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _isSlidesLoopEnabled[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _isSlidesLoopEnabled[key];
    }
  });
});
var _shouldShowNavigationArrows = require("./shouldShowNavigationArrows");
Object.keys(_shouldShowNavigationArrows).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _shouldShowNavigationArrows[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shouldShowNavigationArrows[key];
    }
  });
});
var _shouldShowNextArrow = require("./shouldShowNextArrow");
Object.keys(_shouldShowNextArrow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _shouldShowNextArrow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shouldShowNextArrow[key];
    }
  });
});
var _shouldShowPreviousArrow = require("./shouldShowPreviousArrow");
Object.keys(_shouldShowPreviousArrow).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _shouldShowPreviousArrow[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shouldShowPreviousArrow[key];
    }
  });
});
//# sourceMappingURL=index.js.map